import { type Enum } from '@webapp/infrastructure/types/Enum'

export const CatalogItemTagVariants = {
  DEFAULT: 'default',
  WARNING: 'warning',
} as const

export type CatalogItemTagVariant = Enum<typeof CatalogItemTagVariants>
